import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { StatusBadge, Spinner } from "../../components/Brand";
import { currency, fmtDate } from "../../lib/status";

export default function TechJobs() {
    const [jobs, setJobs] = useState(null);
    const [filter, setFilter] = useState("active");

    useEffect(() => {
        api.get("/bookings").then(({ data }) => setJobs(data));
    }, []);

    if (!jobs) return <Spinner />;

    const ACTIVE = [
        "technician_assigned",
        "technician_accepted",
        "technician_on_the_way",
        "technician_arrived",
        "job_started",
    ];
    const COMPLETED = ["job_completed", "customer_confirmed", "invoice_generated", "payment_completed"];

    let filtered;
    if (filter === "active") filtered = jobs.filter((j) => ACTIVE.includes(j.status));
    else if (filter === "completed") filtered = jobs.filter((j) => COMPLETED.includes(j.status));
    else filtered = jobs;

    return (
        <div className="space-y-5">
            <div className="lx-label text-[#B2912A]">Jobs</div>
            <h1 className="font-sans font-bold text-3xl text-[#0E0E0E] tracking-tight">Your queue</h1>

            <div className="flex gap-2">
                {[
                    ["active", "Active"],
                    ["completed", "Completed"],
                    ["all", "All"],
                ].map(([v, l]) => (
                    <button
                        key={v}
                        onClick={() => setFilter(v)}
                        data-testid={`tech-filter-${v}`}
                        className={`px-4 py-2 text-xs uppercase tracking-wider border ${
                            filter === v
                                ? "bg-[#180A21] text-[#D4AF37] border-[#180A21]"
                                : "border-[#E5E2DC] text-[#555]"
                        }`}
                    >
                        {l} ({v === "active" ? jobs.filter((j) => ACTIVE.includes(j.status)).length : v === "completed" ? jobs.filter((j) => COMPLETED.includes(j.status)).length : jobs.length})
                    </button>
                ))}
            </div>

            {filtered.length === 0 ? (
                <div className="bg-white p-10 text-center text-[#555]">
                    No jobs in this view.
                </div>
            ) : (
                <div className="space-y-3">
                    {filtered.map((j) => (
                        <Link
                            key={j.id}
                            to={`/technician/jobs/${j.id}`}
                            data-testid={`tech-job-${j.booking_number}`}
                            className="block bg-white p-5 border-l-4 border-[#D4AF37] hover:shadow-lg transition"
                        >
                            <div className="flex items-center justify-between gap-3 mb-2 flex-wrap">
                                <span className="lx-label text-[#B2912A]">{j.booking_number}</span>
                                <StatusBadge status={j.status} />
                            </div>
                            <div className="font-sans font-semibold text-lg text-[#0E0E0E] leading-tight">
                                {j.service?.name}
                            </div>
                            <div className="text-xs text-[#555] mt-1">
                                {j.customer?.name} · {fmtDate(j.scheduled_at)}
                            </div>
                            <div className="text-xs text-[#555] mt-1">
                                {j.address?.line1}, {j.address?.city}
                            </div>
                            <div className="mt-3 pt-3 border-t border-[#F3F2F0] flex items-center justify-between">
                                <div className="lx-label text-[#555]">Payout</div>
                                <div className="font-serif text-xl text-[#180A21]">
                                    {currency(j.technician_payout, j.currency)}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
